"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createPrivateContext = createPrivateContext;
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/weak-map"));
var _string = require("../string");
const idMap = {};
function createPrivateContext(id = (0, _string.makeUid)()) {
  let _contextVars = idMap[id];
  if (!(_contextVars instanceof _weakMap.default)) {
    idMap[id] = _contextVars = new _weakMap.default();
  }
  return function (contextObj) {
    if (!_contextVars.has(contextObj)) {
      _contextVars.set(contextObj, {});
    }
    return _contextVars.get(contextObj);
  };
}